export default __webpack_public_path__ + "831548d16775fb69ef4a754634ccdac0.svg";